import { FC } from "react";
import { CancelIcon, CancelIconWhite } from "assets/vectors/close-icon";
import { IconWrapper } from "./close-icon.style";

type Props = {
   handleClose: () => void;
   isWhite?: boolean;
   className?: string;
};

const CloseIcon: FC<Props> = ({ handleClose, isWhite, ...rest }) => {
   return (
      <IconWrapper
         role="button"
         onClick={handleClose}
         onKeyDown={handleClose}
         tabIndex={0}
         {...rest}
      >
         {isWhite ? <CancelIconWhite /> : <CancelIcon />}
      </IconWrapper>
   );
};

export { CloseIcon };
